import { cn } from "@/lib/utils";
import splitkartLogo from "@/assets/branding/splitkart-logo-final.jpg";

interface SplitkartLogoProps {
  className?: string;
  theme?: "light" | "dark";
  showText?: boolean;
}

export function SplitkartLogo({
  className,
  theme = "dark",
  showText = true,
}: SplitkartLogoProps) {
  return (
    <div className={cn("flex items-center", className)} aria-label="Splitkart trademark">
      <img
        src={splitkartLogo}
        alt="Splitkart"
        className={cn(
          "block w-auto object-contain",
          showText ? "h-14 sm:h-16" : "h-10",
          theme === "light" ? "brightness-0 invert" : "",
        )}
      />
    </div>
  );
}
